<template>
    <div ref="coneBar" class="container"></div>
</template>

<script>
import echarts from 'echarts';
import {coneData} from '@/runtime-components/data';
import {coneBar} from '@/runtime-components/config/chart.config'

export default {
    name: 'de-pictorialBar',
    props: {
        color: {
            type: String,
            default: '#e54035'
        },
        data: {
            type: [Array, Object],
            default: () => {
                return coneData();
            }
        }
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    watch: {
        color(v) {
            let chart = this.getChart().chart;
            chart && (chart.setOption({
                color: [v],
                xAxis: {
                    axisLabel: {
                        color: v
                    }
                }
            }));
        },
        data: {
            handler(v) {
                let chart = this.getChart().chart;
                let data = this.dealData(v);
                chart && (chart.setOption({
                    xAxis: {
                        data: data.xData
                    },
                    series: [{
                        name: 'hill',
                        data: data.singleData,
                    }, {
                        data: data.data
                    }]
                }));
            },
            deep: true
        }
    },
    methods: {
        initChart() {
            let chartIns = this.getChart();
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs['coneBar']);
                let data = this.dealData(this.data);
                let option = coneBar(data);
                chartIns.chart.setOption(option);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        dealData(v) {
            let singleData = [];
            let xData = [];
            let mixData = [];
            v.forEach(item => {
                singleData.push(item.value);
                xData.push(item.name);
                mixData.push({
                    value: item.value,
                    symbol: item.symbol,
                    symbolSize: item.symbolSize
                });
            });
            return {
                xData: xData,
                data: mixData,
                singleData: singleData
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style lang="less">
@import url('~@/runtime-components/assets/common.css');
</style>